import { MCStatus } from 'src/constants/mc/enums'
import { State } from '../reducers/types'
import { MCCounts, MCCustomer, MCWithPendingRequests } from 'src/interfaces/mc'

export const getMCCounts = (state: State): MCCounts | null => state.mc.mcCounts

export const getHasRequests = (state: State): boolean =>
  Boolean(state.mc.mcsWithPendingRequests.length)

export const getHasCustomersToLink = (state: State): boolean =>
  state.mc.mcCustomers.some((item) => item.status === MCStatus.Invited)

export const getMCCustomers = (state: State): MCCustomer[] => state.mc.mcCustomers

export const getMCWithPendingRequests = (state: State): MCWithPendingRequests[] =>
  state.mc.mcsWithPendingRequests

export const getNotDeactivatedMCCustomers = (state: State): MCCustomer[] =>
  state.mc.mcCustomers.filter(
    (item) => item.status !== MCStatus.Deactivated && item.status !== MCStatus.Rejected,
  )
